import React from "react"

import ReportsTable from "./components/tables/ReportsTable";

import AuthManager from "../utils/AuthManager";

export default class Reports extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      currentUser: AuthManager.currentUser
    }
  }

  componentDidMount() {

  }

  render() {
    let {

    } = this.state

    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <ReportsTable
              title={"Reports"}
            />
          </div>
        </div>
      </>
    )
  }

}
